import ReactGA from 'react-ga4';

// Initialize Google Analytics with your Measurement ID
export const initGA = (trackingId: string) => {
  if (!trackingId) {
    console.warn('Google Analytics Measurement ID is missing');
    return;
  }

  ReactGA.initialize(trackingId);
  console.log('Google Analytics initialized with ID:', trackingId);
};

// Track page views
export const trackPageView = (path: string) => {
  ReactGA.send({ hitType: 'pageview', page: path });
  console.log('Page view tracked:', path);
};

// Custom event tracking
export const trackEvent = (
  category: string, 
  action: string, 
  label?: string, 
  value?: number
) => {
  ReactGA.event({
    category,
    action,
    label,
    value
  });
  console.log('Event tracked:', { category, action, label, value });
};

// Track user
export const setUser = (userId: string) => {
  ReactGA.set({ userId });
  console.log('User ID set for tracking:', userId);
};

// Custom error tracking
export const trackError = (description: string, fatal: boolean = false) => {
  // ReactGA4 doesn't have exception method, so we use event instead
  ReactGA.event({
    category: 'Error',
    action: description,
    label: fatal ? 'Fatal' : 'Non-fatal'
  });
  console.log('Error tracked:', { description, fatal });
};